import { ChangeDetectorRef, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';

import { SelectBaseComponent } from '../select-base';

@Component({
  selector: 'app-asset-type-select',
  templateUrl: './asset-type-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AssetTypeSelectComponent),
      multi: true
    }
  ]
})
export class AssetTypeSelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
  }

  getUrl(searchValue: string): string {
    let url = `api/ADAccountLinks/query?$top=50&$skip=0&$orderby=assetType asc`;
    var filter = ``;
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      filter = `contains(assetType, '${encodeURIComponent(searchStr)}')`;
    }
    if (filter) url = `${url}&$filter=${filter}`;

    return url;
  }

  // set the location want to navigate
  jump(): string {
    return '/gl/asset-management/0';
  }

  // set the param
  queryParam(): String {
    return 'Asset';
  }
}
